import { makeObservable, observable, action } from 'mobx'

class WithholdingListItem {
    constructor(
        id,
        insuranceCompany,
        multiQuoteType,
        displayName,
        insuredAmount,
        subscriptionAmount,
        createdAt,
        validTo,
        policyId,
        policyNumber,
        amendmentNumber,
        brokerName,
    ) {
        this.id = id
        this.insuranceCompany = insuranceCompany
        this.multiQuoteType = multiQuoteType
        this.displayName = displayName
        this.insuredAmount = insuredAmount
        this.subscriptionAmount = subscriptionAmount
        this.createdAt = createdAt
        this.validTo = validTo
        this.policyId = policyId
        this.policyNumber = policyNumber
        this.amendmentNumber = amendmentNumber
        this.brokerName = brokerName
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    static fromJson({
        id,
        insuranceCompany,
        multiQuoteType,
        displayName,
        insuredAmount,
        subscriptionAmount,
        createdAt,
        validTo,
        policyId,
        policyNumber,
        amendmentNumber,
        brokerName,
    }) {
        return new WithholdingListItem(
            id,
            insuranceCompany,
            multiQuoteType,
            displayName,
            insuredAmount,
            subscriptionAmount,
            createdAt,
            validTo,
            policyId,
            policyNumber,
            amendmentNumber,
            brokerName,
        )
    }
}

export default WithholdingListItem
